export default {
	title: 'إضافة يوم دوام',
	enterTime: 'وقت الدخول',
	leaveTime: 'وقت الخروج',
	employee: 'موظف',

	workTime: 'عدد الساعات:',
	late: 'التاخير:',
	earlyLeave: 'الانصراف المبكر:',
	extra: 'الإضافي:',
	'take-full-day-attendance': 'تسجيل يوم عمل كامل'
};
